import { Rules } from '../../lib/phinxapp/permission/types';

export const permission: Rules[] = [];
